export default function FinalCTA() {
  return (
    <section
      id="cta"
      className="relative py-[clamp(60px,10vh,120px)] bg-[#06b6d4]"
      style={{
        // Static gradient: the previous background-position animation was a
        // continuously repainting, non-composited animation (Lighthouse-flagged).
        background: 'linear-gradient(135deg, #06b6d4, #0891b2)',
      }}
    >
      <div className="max-w-[800px] mx-auto px-6 text-center final-cta-content">
        <h2 className="text-[clamp(28px,3vw,42px)] font-bold leading-[1.15] tracking-[-0.015em] text-[#0d1117]">
          Stop missing bids. Start winning them.
        </h2>
        <p className="mt-4 text-[clamp(16px,1.5vw,20px)] leading-[1.6] text-[#0f172a]">
          Join hundreds of New England contractors who never miss an opportunity.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://app.procuralerts.com/register"
            className="bg-[#0d1117] text-white font-semibold px-10 py-4 rounded-lg hover:bg-[#1f2937] transition-all duration-200 text-base"
          >
            Start for free
          </a>
          <a
            href="mailto:hello@procuralerts.com"
            className="border-2 border-[#0d1117] text-[#0d1117] font-semibold px-10 py-4 rounded-lg hover:bg-[rgba(13,17,23,0.1)] transition-all duration-200 text-base"
          >
            Talk to our team
          </a>
        </div>
      </div>
    </section>
  )
}
